import React from 'react';
import { SteerageStats } from './SteerageStats';
import { Box } from '@material-ui/core';
import { APIProvider } from '@vis.gl/react-google-maps';

const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

/**
 * Overview page for Steerage that displays statistics
 */
export function SteerageOverviewPage() {
  return (
    <Box>
      <APIProvider apiKey={apiKey}>
        <SteerageStats />
      </APIProvider>
    </Box>
  );
}

export default SteerageOverviewPage;
